import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";

export default function Chart({ theme = "light" , data = {}}) {
  const option = {
    title: {
      text: "Gráfico semanal",
    },
    tooltip: {},
    xAxis: {
      data: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
    },
    yAxis: {},
    series: [
      {
        name: "Ventas",
        type: "line",
        data: [data?.lunes ?? 0, data?.martes ?? 0, data?.miercoles ?? 0, data?.jueves ?? 0, data?.viernes ?? 0, data?.sabado ?? 0, data?.domingo ?? 0],
      },
    ],
  };

  return (
    <>
      <ReactECharts
        option={option}
        theme={theme} // <-- aquí indicamos el tema
        style={{ height: 400, width: "100%"}}
      />
    </>
  );
}

Chart.propTypes = {
  theme: PropTypes.string,
  data: PropTypes.object,   
};